

export const LoginInfo = () =>{
    let info = localStorage.getItem('lesson_session')
    info = JSON.parse(info);
    return info;
}

